/**
 * EL COLOR DE LAS TARJETAS DE TIPO (MAD-TIPO-TARJETA-APARIENCIA-T1, maqueta 1N8aGLYswrjs1DcjV2hzTm con SI #44082; corte de
 * la prueba #44456: solo la paleta, la foto despues).
 *
 * Cada tipo de una linea (Fibrocemento, Losa, superboard...) puede llevar uno de 8 tonos de los materiales de Maderinco;
 * sin tono guardado la tarjeta sale como hoy (uno de 12 degradados por el nombre). El tono se guarda por (linea, tipo)
 * en la API (contrato propuesto a A en #44460). Sin DOM: lo prueba scripts/check-tono-tipo.mjs.
 *
 * @module application/presupuestos/tonoDeTipo
 */

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** Los 8 tonos aprobados, en el orden de la maqueta: clave (lo que guarda la API), nombre y el degradado. */
export const PALETA = [
  { clave: 'madera-clara', nombre: 'Madera clara', de: '#a07a4c', a: '#7a5a36' },
  { clave: 'nogal', nombre: 'Nogal', de: '#6a4532', a: '#4a3022' },
  { clave: 'cedro', nombre: 'Cedro', de: '#94553a', a: '#6c3d28' },
  { clave: 'arcilla', nombre: 'Arcilla', de: '#a0603e', a: '#7a462c' },
  { clave: 'verde-monte', nombre: 'Verde monte', de: '#4f6040', a: '#38452d' },
  { clave: 'pizarra', nombre: 'Pizarra', de: '#3e5068', a: '#2b384a' },
  { clave: 'arena', nombre: 'Arena', de: '#9a8a64', a: '#746746' },
  { clave: 'grafito', nombre: 'Grafito', de: '#4a4d55', a: '#33363c' }
];
const CLAVES = new Set(PALETA.map((p) => p.clave));

/** Los tonos de una linea desde la lectura ({ tipo: clave } en snake o camel), solo con claves de la paleta. */
export function tonosDeLinea(linea) {
  const crudo = linea && (linea.tonos ?? linea.Tonos);
  const out = {};
  if (crudo && typeof crudo === 'object') for (const [t, c] of Object.entries(crudo)) if (CLAVES.has(texto(c))) out[texto(t)] = texto(c);
  return out;
}

/** El tono guardado de un tipo (sin mirar mayusculas ni espacios), o null si sale como hoy. */
export function tonoGuardado(tonos, tipo) {
  const t = texto(tipo).toLowerCase();
  const k = Object.keys(tonos || {}).find((x) => texto(x).toLowerCase() === t);
  // Solo vale una clave de la paleta: un valor raro sale como hoy (la lectura trae los tonos en crudo).
  return k && CLAVES.has(texto(tonos[k])) ? texto(tonos[k]) : null;
}

/** El cuerpo de PUT .../lineas/{n}/tono: { tipo, tono } con tono de la paleta o null (vuelve a como sale hoy). */
export function cuerpoDeTono(tipo, clave) {
  const t = texto(tipo);
  if (!t) return { ok: false, motivo: 'sin tipo' };
  const c = texto(clave);
  if (c && !CLAVES.has(c)) return { ok: false, motivo: 'ese color no es de la paleta' };
  return { ok: true, cuerpo: { tipo: t, tono: c || null } };
}

/** Lo que dice el editor despues de guardar (o al no poder). */
export function fraseDelTono(res, clave) {
  if (res && res.ok) return clave ? `Guardado: la tarjeta sale en ${(PALETA.find((p) => p.clave === clave) || {}).nombre || clave}.` : 'Guardado: la tarjeta vuelve a salir como hoy.';
  const c = res && res.error && res.error.code;
  if (c === 'NOT_IMPLEMENTED') return 'Falta que la API guarde el color de las tarjetas: no cambió nada.';
  if (c === 'FORBIDDEN') return 'No tienes permiso para cambiar cómo se ven las tarjetas.';
  return 'No se guardó. Intenta de nuevo en un momento.';
}
